import { FC } from 'react';
import { Button, Form } from 'antd';
import { CalendarSvg } from '../../components/Icons/CalendarIcon';
import { ClockIcon } from '../../components/Icons/ClockIcon';
import PitchFormImage from '../../assets/PitchFormImage.svg';
import { FloatTextArea } from '../../components/Fields/FloatTextArea';
import { useSubmitPitchMutation } from '../../api/tenders';
import { Loader } from '../../components/Loader/Loader';
import { useSearchParams } from 'react-router-dom';
import { RequsetNewSlotSuccess } from './success-screens/RequsetNewSlotSuccess';

export interface RequestNewSlotScreenProps {
    data: any;
}

export const RequestNewSlotScreen: FC<RequestNewSlotScreenProps> = ({ data }) => {
    const [searchParams] = useSearchParams();
    const signature = searchParams.get('signature');
    const [form] = Form.useForm();
    const [submitPitch, { isSuccess, isLoading }] = useSubmitPitchMutation();

    const handleContinue = (values: any) => {
        const formData = new FormData();

        data?.slots?.forEach((slot: any, index: number) => {
            formData.append(`slots[${index}][date]`, slot.date);
            formData.append(`slots[${index}][time_from]`, slot.time_from);
            formData.append(`slots[${index}][time_to]`, slot.time_to);
        });

        formData.append('status', 'slots_request');

        if (values?.reason) {
            formData.append('reason', values?.reason);
        }

        submitPitch({
            signature: signature,
            data: formData
        });
    };

    return isSuccess ? (
        <RequsetNewSlotSuccess />
    ) : (
        <div className="SupplierCompanyPitches__success success">
            <div className="supplier-pitch__content request-alt-slot">
                <div className="request-alt-slot__inner">
                    <h1 className="request-alt-slot__title">
                        <span className="request-alt-slot__title-line">Request an Alternative</span>
                        <span className="request-alt-slot__title-line">Pitch Slot</span>
                    </h1>

                    <div className="request-alt-slot__section">
                        <p className="request-alt-slot__intro">
                            You are currently scheduled to pitch for the following service opportunity:
                        </p>
                        <div className="request-alt-slot__card">
                            <div className="request-alt-slot__card-headings">
                                <p className="request-alt-slot__customer">{data?.company?.name || '—'}</p>
                                <p className="request-alt-slot__expense">{data?.expense_area_name || '—'}</p>
                            </div>
                            <div className="request-alt-slot__meta-row">
                                <div className="request-alt-slot__meta">
                                    <CalendarSvg fill="#001965" className="" />
                                    <span className="request-alt-slot__meta-text">{data?.assigned_slot?.date}</span>
                                </div>
                                <div className="request-alt-slot__meta">
                                    <ClockIcon fill="#001965" />
                                    <span className="request-alt-slot__meta-text">
                                        {data?.assigned_slot?.time_from} - {data?.assigned_slot?.time_to}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="request-alt-slot__section">
                        <p className="request-alt-slot__field-label">
                            Reason for Rescheduling & Proposed Alternative Slots
                        </p>
                        <div className="request-alt-slot__textarea-wrap">
                            <Form form={form} onFinish={handleContinue}>
                                <Form.Item
                                    name="reason"
                                    rules={[{ required: true, message: 'This field is required' }]}
                                >
                                    <FloatTextArea
                                        floatLabel={'Provide a Reason'}
                                        hasError={() => !!form.getFieldError(['reason']).length}
                                        required
                                    />
                                </Form.Item>

                                <Button type="primary" className="request-alt-slot__submit" block htmlType="submit">
                                    {isLoading ? <Loader /> : 'Continue'}
                                </Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <img src={PitchFormImage} className="image__item" alt="" />
        </div>
    );
};
